import { ErrorCodes } from 'constants/errors.constants';
import APIError from 'exceptions/APIError';
import { postEvaluateShipment } from '../fetchers';
import {
  EvaluateShipmentPayloadDTO,
  EvaluateShipmentRespDTO,
} from '../fetchers/evaluateShipment.fetcher.dto';

export const evaluateShipment = async (
  orgId: number,
  shipmentPk: number,
  cmsReference: string,
): Promise<EvaluateShipmentRespDTO> => {
  try {
    const params: EvaluateShipmentPayloadDTO = {
      shipment_pk: shipmentPk,
      cms_reference: cmsReference,
    };

    const { data } = await postEvaluateShipment(orgId, params);
    return EvaluateShipmentRespDTO.fromApiData(data);
  } catch (error) {
    if (error instanceof APIError) {
      // If any error occurs, we assume that the shipment is eligible for return and all line items are eligible for return
      return EvaluateShipmentRespDTO.create({
        isShipmentEligibleForReturn: true,
        nonEligibleLineItems: [],
      });
    }

    throw error;
  }
};
